/**
 * Coach Payment Tracking Types
 * Manages payment records for coaches covering training sessions
 */

export interface CoachPayment {
  paymentId: string;
  coachId: string;
  coachName: string;
  periodStart: string;
  periodEnd: string;
  totalHours: number;
  totalAmount: number;
  status: PaymentStatus;
  createdDate: string;
  createdByName: string;
  paidDate?: string;
  paidByName?: string;
  confirmedDate?: string;
  adminNotes?: string;
  coachNotes?: string;
  paymentEvents: CoachPaymentEvent[];
}

export type PaymentStatus = 'PendingAdminReview' | 'PaidByAdmin' | 'ConfirmedByCoach';

export const PaymentStatusDisplayNames: Record<PaymentStatus, string> = {
  PendingAdminReview: 'Ellenőrzés alatt',
  PaidByAdmin: 'Kifizetve',
  ConfirmedByCoach: 'Edző által visszaigazolva'
};

export const PaymentStatusColors: Record<PaymentStatus, string> = {
  PendingAdminReview: 'warning',
  PaidByAdmin: 'info',
  ConfirmedByCoach: 'success'
};

export interface CoachPaymentEvent {
  paymentEventId: string;
  eventId?: string;
  eventName: string;
  category: string;
  description?: string;
  eventDate: string;
  startTime?: string;
  endTime?: string;
  hours: number;
  amount: number;
  isManualEntry: boolean;
  coachAttended: boolean;
  // Az esemény teljes hossza; ha hours kevesebb, az edző részben volt jelen.
  eventHours?: number | null;
  presentFrom?: string | null;
  presentUntil?: string | null;
}

export interface PayableEvents {
  coachId: string;
  coachName: string;
  hourlyRate: number | null;
  periodStart: string;
  periodEnd: string;
  totalEvents: number;
  paidEvents: number;
  payableEvents: number;
  totalPayableHours: number;
  totalPayableAmount: number;
  totalCollectedForPayable: number;
  netPayableAmount: number;
  events: PayableEvent[];
}

export interface PayableEvent {
  eventId: string;
  eventName: string;
  eventDate: string;
  startTime: string;
  endTime: string;
  hours: number;
  amount: number;
  isPaid: boolean;
  paymentId?: string;
  paymentStatus?: PaymentStatus;
  coachAttended: boolean;
  collectedAmount: number;
  // Az esemény teljes hossza; ha hours kevesebb, az edző részben volt jelen.
  eventHours?: number;
  presentFrom?: string | null;
  presentUntil?: string | null;
}

export interface CreateCoachPayment {
  coachId: string;
  periodStart: Date;
  periodEnd: Date;
  eventIds: string[];
  customItems: CustomPaymentItem[];
  adminNotes?: string;
}

export interface CustomPaymentItem {
  category: PaymentItemCategory;
  description: string;
  date: Date;
  hours?: number;
  amount: number;
}

export type PaymentItemCategory = 'Training' | 'Travel' | 'Bonus' | 'Other' | 'Deduction';

export const PaymentItemCategoryDisplayNames: Record<PaymentItemCategory, string> = {
  Training: 'Edzés',
  Travel: 'Útiköltség',
  Bonus: 'Bónusz',
  Other: 'Egyéb',
  Deduction: 'Levonás'
};

export interface ConfirmPayment {
  coachNotes?: string;
}
